import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ArrowLeft, BarChart3 } from "lucide-react";
import { GymStatsDashboard } from "@/components/gym-stats/GymStatsDashboard";
import { Skeleton } from "@/components/ui/skeleton";

const EstadisticasGimnasio = () => {
  const { gymId } = useParams();
  const navigate = useNavigate();

  const { data: gym, isLoading } = useQuery({
    queryKey: ["gym", gymId],
    queryFn: async () => {
      if (!gymId) return null;
      const { data, error } = await supabase
        .from("gyms")
        .select("*")
        .eq("id", gymId)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: !!gymId,
  });

  if (!gymId) {
    return (
      <div className="min-h-screen pt-16 bg-background flex items-center justify-center">
        <p className="text-destructive">ID de gimnasio no válido</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-16 bg-background">
      <header className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-16 z-10">
        <div className="container py-4">
          <Button
            variant="ghost"
            onClick={() => navigate("/configuracion?tab=admin&subtab=gym")}
            className="mb-4 text-foreground hover:bg-muted"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Volver
          </Button>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <BarChart3 className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-foreground">
                Estadísticas
              </h1>
              {isLoading ? (
                <Skeleton className="h-5 w-40 mt-1" />
              ) : (
                <p className="text-muted-foreground">{gym?.name}</p>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="container py-6">
        {isLoading ? (
          <div className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {[...Array(4)].map((_, i) => (
                <Skeleton key={i} className="h-32" />
              ))}
            </div>
          </div>
        ) : gym ? (
          <GymStatsDashboard gymId={gymId} gymName={gym.name} />
        ) : (
          <p className="text-center text-muted-foreground">
            No se encontró el gimnasio
          </p>
        )}
      </main>
    </div>
  );
};

export default EstadisticasGimnasio;
